import { getTreeItemPadding } from './types';

interface TreeEmptyProps {
  depth: number;
  message?: string;
}

export function TreeEmpty({ depth, message = 'No files found' }: TreeEmptyProps) {
  return (
    <div className="text-xs text-muted-foreground py-1" style={getTreeItemPadding(depth)}>
      {message}
    </div>
  );
}
